import { useRef } from "react";
import { FaBriefcase, FaGlobe, FaIndustry, FaLaptopCode, FaUsers } from "react-icons/fa";

export const get_total_couts = [
    {
        title: "Total Count",
        count: "10M+",
        icon: FaUsers,
        description: "Available Leads",
    },
    {
        title: "Country",
        count: "100+",
        icon: FaGlobe,
        description: "Covered Countries",
    },
    {
        title: "Industries",
        count: "20K+",
        icon: FaIndustry,
        description: "Industry Segments",
    },
    {
        title: "Job Title",
        count: "200K+",
        icon: FaBriefcase,
        description: "Verified Titles",
    },
    {
        title: "Technology",
        count: "10K+",
        icon: FaLaptopCode,
        description: "Tech Categories",
    },
];

export function RefData() {
    const typeaheadRef = useRef(null);
    const contactTypeRef = useRef(null);
    const locationRef = useRef(null);
    const companyRef = useRef(null);
    const industryRef = useRef(null);
    const technologyRef = useRef(null);
    const continentRef = useRef(null);

    const sectionMap = {
        "Contact Type": contactTypeRef,
        "Location": locationRef,
        "Company": companyRef,
        "Industry": industryRef,
        "Technology": technologyRef,
        // "Continent Search": continentRef
    };

    return {
        typeaheadRef,
        contactTypeRef,
        locationRef,
        companyRef,
        industryRef,
        technologyRef,
        continentRef,
        sectionMap
    };
}

export const jobfunctionOptions = [
    { label: "Accounting", value: "accounting" },
    { label: "Administrative", value: "administrative" },
    { label: "Arts and Design", value: "arts_and_design" },
    { label: "Business Development", value: "business_development" },
    { label: "Community and Social Services", value: "community_and_social_services" },
    { label: "Consulting", value: "consulting" },
    { label: "Customer Success and Support", value: "customer_success_and_support" },
    { label: "Education", value: "education" },
    { label: "Engineering", value: "engineering" },
    { label: "Entrepreneurship", value: "entrepreneurship" },
    { label: "Finance", value: "finance" },
    { label: "Healthcare Services", value: "healthcare_services" },
    { label: "Human Resources", value: "human_resources" },
    { label: "Legal", value: "legal" },
    { label: "Marketing", value: "marketing" },
    { label: "Media and Communication", value: "media_and_communication" },
    { label: "Operations", value: "operations" },
    { label: "Product Management", value: "product_management" },
    { label: "Program and Project Management", value: "program_and_project_management" },
    { label: "Purchasing", value: "purchasing" },
    { label: "Quality Assurance", value: "quality_assurance" },
    { label: "Real Estate", value: "real_estate" },
    { label: "Research", value: "research" },
    { label: "Sales", value: "sales" },
    { label: "Support", value: "support" },
    { label: "Administration", value: "administration" }
];


export const seniorityOptions = [
    { label: "Owner", value: "owner" },
    { label: "Founder", value: "founder" },
    { label: "C-Suite", value: "c_suite" },
    { label: "Partner", value: "partner" },
    { label: "VP", value: "vp" },
    { label: "Head", value: "head" },
    { label: "Director", value: "director" },
    { label: "Manager", value: "manager" },
    { label: "Senior", value: "senior" },
    { label: "Entry", value: "entry" },
    { label: "Intern", value: "intern" },
    { label: "C-Level", value: "c-level" }
];

export const sortingOptions = [
    // { value: "", label: "Select sorting options" },
    { value: "firstname, A-Z", label: "Sort by Name A-Z" },
    { value: "firstname, Z-A", label: "Sort by Name Z-A" },
    { value: "company, A-Z", label: "Sort by Company A-Z" },
    { value: "company, Z-A", label: "Sort by Company Z-A" },
    { value: "industry, A-Z", label: "Sort by Industry A-Z" },
    { value: "industry, Z-A", label: "Sort by Industry Z-A" },
    { value: "revenue, low-high", label: "Sort by Revenue Low-High" },
    { value: "revenue, high-low", label: "Sort by Revenue High-Low" },
    { value: "employee, low-high", label: "Sort by Employee Size Low-High" },
    { value: "employee, high-low", label: "Sort by Employee Size High-Low" },
];

export const radioOptions = [
    { value: 'yes', label: 'Yes' },
    { value: 'no', label: 'No' }
];

export const sideMenuItems = [
    { label: "Contact Type", icon: <i className="fa fa-address-book"></i> },
    { label: "Location", icon: <i className="fa fa-crosshairs"></i> },
    { label: "Company", icon: <i className="fa fa-briefcase"></i> },
    { label: "Industry", icon: <i className="fa fa-tags"></i> },
    { label: "Technology", icon: <i className="fa fa-database"></i> },
    // { label: "Continent Search", icon: continentImg },
];


export const industryOptions = [
    { label: "Accounting", value: "accounting" },
    { label: "Airlines / Aviation", value: "airlines_aviation" },
    { label: "Alternative Medicine", value: "alternative_medicine" },
    { label: "Animation", value: "animation" },
    { label: "Apparel & Fashion", value: "apparel_fashion" },
    { label: "Architecture & Planning", value: "architecture_planning" },
    { label: "Automotive", value: "automotive" },
    { label: "Banking", value: "banking" },
    { label: "Biotechnology", value: "biotechnology" },
    { label: "Broadcast Media", value: "broadcast_media" },
    { label: "Building Materials", value: "building_materials" },
    { label: "Business Supplies & Equipment", value: "business_supplies_equipment" },
    { label: "Capital Markets", value: "capital_markets" },
    { label: "Chemicals", value: "chemicals" },
    { label: "Civic & Social Organization", value: "civic_social_organization" },
    { label: "Civil Engineering", value: "civil_engineering" },
    { label: "Commercial Real Estate", value: "commercial_real_estate" },
    { label: "Computer & Network Security", value: "computer_network_security" },
    { label: "Computer Games", value: "computer_games" },
    { label: "Computer Hardware", value: "computer_hardware" },
    { label: "Computer Networking", value: "computer_networking" },
    { label: "Computer Software", value: "computer_software" },
    { label: "Construction", value: "construction" },
    { label: "Consumer Electronics", value: "consumer_electronics" },
    { label: "Consumer Goods", value: "consumer_goods" },
    { label: "Consumer Services", value: "consumer_services" },
    { label: "Cosmetics", value: "cosmetics" },
    { label: "Dairy", value: "dairy" },
    { label: "Defense & Space", value: "defense_space" },
    { label: "Design", value: "design" },
    { label: "E-learning", value: "e_learning" },
    { label: "Education Management", value: "education_management" },
    { label: "Electrical & Electronic Manufacturing", value: "electrical_electronic_manufacturing" },
    { label: "Entertainment", value: "entertainment" },
    { label: "Environmental Services", value: "environmental_services" },
    { label: "Events Services", value: "events_services" },
    { label: "Executive Office", value: "executive_office" },
    { label: "Facilities Services", value: "facilities_services" },
    { label: "Farming", value: "farming" },
    { label: "Financial Services", value: "financial_services" },
    { label: "Food & Beverages", value: "food_beverages" },
    { label: "Food Production", value: "food_production" },
    { label: "Government Administration", value: "government_administration" },
    { label: "Graphic Design", value: "graphic_design" },
    { label: "Health, Wellness & Fitness", value: "health_wellness_fitness" },
    { label: "Higher Education", value: "higher_education" },
    { label: "Hospital & Healthcare", value: "hospital_healthcare" },
    { label: "Hospitality", value: "hospitality" },
    { label: "Human Resources", value: "human_resources" },
    { label: "Import & Export", value: "import_export" },
    { label: "Industrial Automation", value: "industrial_automation" },
    { label: "Information Services", value: "information_services" },
    { label: "Information Technology & Services", value: "information_technology_services" },
    { label: "Insurance", value: "insurance" },
    { label: "Internet", value: "internet" },
    { label: "Investment Banking", value: "investment_banking" },
    { label: "Investment Management", value: "investment_management" },
    { label: "Legal Services", value: "legal_services" },
    { label: "Logistics & Supply Chain", value: "logistics_supply_chain" },
    { label: "Luxury Goods & Jewelry", value: "luxury_goods_jewelry" },
    { label: "Machinery", value: "machinery" },
    { label: "Management Consulting", value: "management_consulting" },
    { label: "Manufacturing", value: "manufacturing" },
    { label: "Marketing & Advertising", value: "marketing_advertising" },
    { label: "Media Production", value: "media_production" },
    { label: "Medical Devices", value: "medical_devices" },
    { label: "Mining & Metals", value: "mining_metals" },
    { label: "Nonprofit Organization Management", value: "nonprofit_organization_management" },
    { label: "Oil & Energy", value: "oil_energy" },
    { label: "Online Media", value: "online_media" },
    { label: "Pharmaceuticals", value: "pharmaceuticals" },
    { label: "Printing", value: "printing" },
    { label: "Professional Training & Coaching", value: "professional_training_coaching" },
    { label: "Public Relations & Communications", value: "public_relations_communications" },
    { label: "Real Estate", value: "real_estate" },
    { label: "Research", value: "research" },
    { label: "Restaurants", value: "restaurants" },
    { label: "Retail", value: "retail" },
    { label: "Semiconductors", value: "semiconductors" },
    { label: "Sports", value: "sports" },
    { label: "Software Development", value: "software_development" },
    { label: "Staffing & Recruiting", value: "staffing_recruiting" },
    { label: "Telecommunications", value: "telecommunications" },
    { label: "Transportation", value: "transportation" },
    { label: "Utilities", value: "utilities" },
    { label: "Venture Capital & Private Equity", value: "venture_capital_private_equity" },
    { label: "Veterinary", value: "veterinary" },
    { label: "Warehousing", value: "warehousing" },
    { label: "Wholesale", value: "wholesale" },
    { label: "Writing & Editing", value: "writing_editing" }
];

export const technologyOptions = [
    { label: "AWS Cloud", value: "aws_cloud" },
    { label: "Amazon EC2", value: "amazon_ec2" },
    { label: "Amazon S3", value: "amazon_s3" },
    { label: "Amazon CloudFront", value: "amazon_cloudfront" },
    { label: "Microsoft Azure", value: "microsoft_azure" },
    { label: "Google Cloud Platform", value: "google_cloud_platform" },
    { label: "DigitalOcean", value: "digitalocean" },
    { label: "Heroku", value: "heroku" },
    { label: "Netlify", value: "netlify" },
    { label: "Vercel", value: "vercel" },
    { label: "Cloudflare", value: "cloudflare" },

    { label: "Salesforce", value: "salesforce" },
    { label: "HubSpot", value: "hubspot" },
    { label: "Zoho CRM", value: "zoho_crm" },
    { label: "Microsoft Dynamics 365", value: "microsoft_dynamics_365" },
    { label: "Pipedrive", value: "pipedrive" },
    { label: "Freshsales", value: "freshsales" },
    { label: "SugarCRM", value: "sugarcrm" },
    { label: "Copper", value: "copper" },
    { label: "Insightly", value: "insightly" },
    { label: "Monday CRM", value: "monday_crm" },

    { label: "Marketo", value: "marketo" },
    { label: "Pardot", value: "pardot" },
    { label: "Mailchimp", value: "mailchimp" },
    { label: "ActiveCampaign", value: "activecampaign" },
    { label: "Klaviyo", value: "klaviyo" },
    { label: "Constant Contact", value: "constant_contact" },
    { label: "Iterable", value: "iterable" },
    { label: "Customer.io", value: "customer_io" },
    { label: "Braze", value: "braze" },
    { label: "Drip", value: "drip" },

    { label: "Zendesk", value: "zendesk" },
    { label: "Intercom", value: "intercom" },
    { label: "Freshdesk", value: "freshdesk" },
    { label: "Help Scout", value: "help_scout" },
    { label: "Gorgias", value: "gorgias" },
    { label: "LiveChat", value: "livechat" },
    { label: "Drift", value: "drift" },

    { label: "Google Analytics", value: "google_analytics" },
    { label: "Google Tag Manager", value: "google_tag_manager" },
    { label: "Mixpanel", value: "mixpanel" },
    { label: "Amplitude", value: "amplitude" },
    { label: "Hotjar", value: "hotjar" },
    { label: "Heap", value: "heap" },
    { label: "Segment", value: "segment" },

    { label: "WordPress", value: "wordpress" },
    { label: "Webflow", value: "webflow" },
    { label: "Wix", value: "wix" },
    { label: "Squarespace", value: "squarespace" },
    { label: "Drupal", value: "drupal" },
    { label: "Joomla", value: "joomla" },
    { label: "Contentful", value: "contentful" },
    { label: "Adobe Experience Manager", value: "adobe_experience_manager" },

    { label: "Shopify", value: "shopify" },
    { label: "WooCommerce", value: "woocommerce" },
    { label: "Magento", value: "magento" },
    { label: "BigCommerce", value: "bigcommerce" },
    { label: "PrestaShop", value: "prestashop" },
    { label: "OpenCart", value: "opencart" },
    { label: "Salesforce Commerce Cloud", value: "salesforce_commerce_cloud" },

    { label: "Outreach", value: "outreach" },
    { label: "Salesloft", value: "salesloft" },
    { label: "Apollo", value: "apollo" },
    { label: "Gong", value: "gong" },
    { label: "Chorus", value: "chorus" },
    { label: "Groove", value: "groove" },
    { label: "Yesware", value: "yesware" },

    { label: "Google Workspace", value: "google_workspace" },
    { label: "Microsoft 365", value: "microsoft_365" },
    { label: "Slack", value: "slack" },
    { label: "Zoom", value: "zoom" },
    { label: "Cisco Webex", value: "cisco_webex" },
    { label: "Dropbox", value: "dropbox" },
    { label: "Box", value: "box" },

    { label: "GitHub", value: "github" },
    { label: "GitLab", value: "gitlab" },
    { label: "Bitbucket", value: "bitbucket" },
    { label: "Jira", value: "jira" },
    { label: "Confluence", value: "confluence" },
    { label: "Jenkins", value: "jenkins" },
    { label: "CircleCI", value: "circleci" },
    { label: "Travis CI", value: "travis_ci" },
    { label: "Docker", value: "docker" },
    { label: "Kubernetes", value: "kubernetes" },
    { label: "Postman", value: "postman" },

    { label: "MySQL", value: "mysql" },
    { label: "PostgreSQL", value: "postgresql" },
    { label: "MongoDB", value: "mongodb" },
    { label: "Redis", value: "redis" },
    { label: "Microsoft SQL Server", value: "microsoft_sql_server" },
    { label: "Oracle Database", value: "oracle_database" },
    { label: "Snowflake", value: "snowflake" },
    { label: "Cassandra", value: "cassandra" },
    { label: "Elasticsearch", value: "elasticsearch" },

    { label: "Tableau", value: "tableau" },
    { label: "Power BI", value: "power_bi" },
    { label: "Looker", value: "looker" },
    { label: "Databricks", value: "databricks" },
    { label: "Dataiku", value: "dataiku" },

    { label: "OpenAI", value: "openai" },
    { label: "Anthropic", value: "anthropic" },
    { label: "Hugging Face", value: "hugging_face" },

    { label: "Okta", value: "okta" },
    { label: "OneLogin", value: "onelogin" },
    { label: "Duo Security", value: "duo_security" },
    { label: "CrowdStrike", value: "crowdstrike" },
    { label: "Palo Alto Networks", value: "palo_alto_networks" },
    { label: "Snyk", value: "snyk" },

    { label: "Google Ads", value: "google_ads" },
    { label: "Meta Ads", value: "meta_ads" },
    { label: "LinkedIn Ads", value: "linkedin_ads" },
    { label: "Bing Ads", value: "bing_ads" },
    { label: "AdRoll", value: "adroll" },
    { label: "Criteo", value: "criteo" },

    { label: "Stripe", value: "stripe" },
    { label: "PayPal", value: "paypal" },
    { label: "Braintree", value: "braintree" },

    { label: "Twilio", value: "twilio" },
    { label: "SendGrid", value: "sendgrid" },
    { label: "Mailgun", value: "mailgun" },

    { label: "React", value: "react" },
    { label: "Angular", value: "angular" },
    { label: "Vue.js", value: "vue_js" },
    { label: "Next.js", value: "next_js" },
    { label: "Nuxt.js", value: "nuxt_js" },
    { label: "Node.js", value: "node_js" },
    { label: "Express", value: "express" },
    { label: "Django", value: "django" },
    { label: "Flask", value: "flask" },
    { label: "Laravel", value: "laravel" },
    { label: "Ruby on Rails", value: "ruby_on_rails" },
    { label: "Spring Boot", value: "spring_boot" },
    { label: "ASP.NET", value: "asp_net" },

    { label: "Bootstrap", value: "bootstrap" },
    { label: "Tailwind CSS", value: "tailwind_css" },
    { label: "jQuery", value: "jquery" },

    { label: "SAP", value: "sap" },
    { label: "Oracle ERP", value: "oracle_erp" },
    { label: "Workday", value: "workday" },
    { label: "ServiceNow", value: "servicenow" },

    { label: "Asana", value: "asana" },
    { label: "Trello", value: "trello" },
    { label: "Monday.com", value: "monday_com" },
    { label: "Notion", value: "notion" },
    { label: "Airtable", value: "airtable" }
];


export const yearlyPlans = [
    {
        name: "Free",
        price: "$0",
        credits: "200 Credits",
        plan_credits: "200 Credits",
        color: "#1664a3",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "Single Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment"
        ]
    },
    {
        name: "Basic",
        price: "$39",
        credits: "54,000 Credits",
        plan_credits: "4,500 Credits",
        color: "#16a34a",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "2 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    },
    {
        name: "Professional",
        price: "$63",
        credits: "72,000 Credits",
        plan_credits: "6,000 Credits",
        popular: true,
        color: "#4f46e5",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "5 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    },
    {
        name: "Enterprise",
        price: "$95",
        credits: "96,000 Credits",
        plan_credits: "8,000 Credits",
        color: "#d97706",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "7 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    }
];

export const monthlyPlans = [
    {
        name: "Free",
        price: "$0",
        credits: "100 Credits",
        plan_credits: "100 Credits",
        color: "#1664a3",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "Single Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment"
        ]
    },
    {
        name: "Basic",
        price: "$49",
        credits: "2,500 Credits",
        plan_credits: "2,500 Credits",
        color: "#16a34a",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "2 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    },
    {
        name: "Professional",
        price: "$79",
        credits: "4,000 Credits",
        plan_credits: "4,000 Credits",
        popular: true,
        color: "#4f46e5",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "5 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    },
    {
        name: "Enterprise",
        price: "$119",
        credits: "6,000 Credits",
        plan_credits: "6,000 Credits",
        color: "#d97706",
        button_color: "#1664a3",
        current_plan_button: "#d97706",
        features: [
            "10 Users",
            "Verified Emails",
            "Verified Mobile Numbers",
            "Data Enrichment",
            "AI Search"
        ]
    }
];

// #region Subscription page
export const sbnType = [
    {
        label: "Free", value: "free"
    },
    {
        label: "Basic", value: "basic"
    },
    {
        label: "Professional", value: "professional"
    },
    {
        label: "Enterprise", value: "enterprise"
    }
]
export const planDuration = [
    {
        label: "Monthly", value: "monthly"
    },
    {
        label: "Yearly", value: "yeraly"
    }
]
// #endregion


// #region activity page dropdown
export const activity_type = [
    { value: "USER_REGISTERED", label: "User Registered" },
    { value: "ACCOUNT_DELETED", label: "Account Deleted" },
    { value: "CONTACT_DOWNLOADED", label: "Contact Downloaded" },
    { value: "SUBSCRIPTION_PURCHASED", label: "Subscription Purchased" },
    { value: "SAVED_SEARCH_CRITERIA", label: "Saved Search Criteria" },
    { value: "DELETE_SEARCH_CRITERIA", label: "Deleted Search Criteria" },
    { value: "LIST_CREATED", label: "List Created" },
    { value: "LIST_DELETED", label: "List Deleted" }
]
// #endregion